import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const StakeholderFilters = ({ 
  searchQuery, 
  onSearchChange, 
  roleFilter, 
  onRoleFilterChange, 
  statusFilter, 
  onStatusFilterChange,
  transactionFilter,
  onTransactionFilterChange,
  onClearFilters,
  onInviteStakeholder 
}) => {
  const roleOptions = [
    { value: 'all', label: 'All Roles' },
    { value: 'Property Owner', label: 'Property Owner' },
    { value: 'Lawyer', label: 'Lawyer' },
    { value: 'Engineer', label: 'Engineer' },
    { value: 'Notary', label: 'Notary' },
    { value: 'Broker', label: 'Broker' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'Active', label: 'Active' },
    { value: 'Pending', label: 'Pending' },
    { value: 'Inactive', label: 'Inactive' }
  ];

  const transactionOptions = [
    { value: 'all', label: 'All Transactions' },
    { value: 'TXN-2025-001', label: 'TXN-2025-001 - Luxury Condo' },
    { value: 'TXN-2025-002', label: 'TXN-2025-002 - Commercial Plaza' },
    { value: 'TXN-2025-003', label: 'TXN-2025-003 - Residential Complex' },
    { value: 'TXN-2025-004', label: 'TXN-2025-004 - Office Building' }
  ];

  const hasActiveFilters = roleFilter !== 'all' || statusFilter !== 'all' || transactionFilter !== 'all' || searchQuery;

  return (
    <div className="bg-card rounded-lg border border-border shadow-soft p-6 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0 lg:space-x-4">
        {/* Search and Filters */}
        <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 flex-1">
          {/* Search */}
          <div className="flex-1 max-w-md">
            <div className="relative">
              <Input
                type="search"
                placeholder="Search stakeholders by name, email, or company..."
                value={searchQuery}
                onChange={(e) => onSearchChange(e?.target?.value)}
                className="pl-10"
              />
              <Icon 
                name="Search" 
                size={16} 
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" 
              />
            </div>
          </div>

          {/* Role Filter */}
          <div className="min-w-[160px]">
            <Select
              options={roleOptions}
              value={roleFilter}
              onChange={onRoleFilterChange}
              placeholder="Filter by role"
            />
          </div>

          {/* Status Filter */}
          <div className="min-w-[140px]">
            <Select
              options={statusOptions}
              value={statusFilter}
              onChange={onStatusFilterChange}
              placeholder="Filter by status"
            />
          </div>

          {/* Transaction Filter */}
          <div className="min-w-[200px]">
            <Select
              options={transactionOptions}
              value={transactionFilter}
              onChange={onTransactionFilterChange}
              placeholder="Filter by transaction"
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center space-x-3">
          {hasActiveFilters && (
            <Button
              variant="outline"
              size="sm"
              onClick={onClearFilters}
              iconName="X"
              iconPosition="left"
              className="text-muted-foreground"
            >
              Clear Filters
            </Button>
          )}
          
          <Button
            variant="default"
            onClick={onInviteStakeholder}
            iconName="UserPlus"
            iconPosition="left"
          >
            Invite Stakeholder
          </Button>
        </div>
      </div>
      {/* Active Filters Display */}
      {hasActiveFilters && (
        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-sm text-muted-foreground">Active filters:</span>
            
            {searchQuery && (
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-accent/10 text-accent">
                Search: "{searchQuery}"
                <button
                  onClick={() => onSearchChange('')}
                  className="ml-1.5 hover:text-accent/80"
                >
                  <Icon name="X" size={12} />
                </button>
              </span>
            )}
            
            {roleFilter !== 'all' && (
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary/10 text-primary">
                Role: {roleFilter}
                <button
                  onClick={() => onRoleFilterChange('all')}
                  className="ml-1.5 hover:text-primary/80"
                >
                  <Icon name="X" size={12} />
                </button>
              </span>
            )}
            
            {statusFilter !== 'all' && (
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-success/10 text-success">
                Status: {statusFilter}
                <button
                  onClick={() => onStatusFilterChange('all')}
                  className="ml-1.5 hover:text-success/80"
                >
                  <Icon name="X" size={12} />
                </button>
              </span>
            )}
            
            {transactionFilter !== 'all' && (
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-warning/10 text-warning">
                Transaction: {transactionFilter}
                <button
                  onClick={() => onTransactionFilterChange('all')}
                  className="ml-1.5 hover:text-warning/80"
                >
                  <Icon name="X" size={12} />
                </button>
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default StakeholderFilters;